import React, { useCallback, useEffect, useState } from "react";
import {getMasterDataReports} from "../../services/integrationService";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper,Button } from "@mui/material";
import "./MasterDataReports.css";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
interface MasterDataReport {
    fileName: string;
    branch: string;
    size: number;
    timestamp: string; 
  } 

export function MasterDataReports() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Master Data Reports"
  const CUR_COMPONENT_COMMON="commonPortal";
    const [masterDataReports, setMasterDataReports] = useState<MasterDataReport[]>([]);
    const headers = ['NAME', 'DISTRICT/BRANCH', 'SIZE(KB)', 'LAST MODIFIED','ACTION'];
    const fetchMasterDataReports = useCallback(async () => {
    try {
        const data = await getMasterDataReports();
        const dataArray =  data.data;
        setMasterDataReports(dataArray);    
    } catch (error) {
        
    }
}, []);
const handleBackClick = () => {
    window.history.back();
  };
  useEffect(() => {
    fetchMasterDataReports();
  }, [fetchMasterDataReports]);
  const formatDate = (timestamp: string) => {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return formattedDate;
  };


  return (
    <>
    <TableContainer component={Paper} sx={{ paddingTop: '5rem', position: "relative", fontWeight: "bold", borderRadius: "10px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",paddingRight:"5rem" }}>
      <Typography variant="h6" fontWeight="medium" sx={{ position: "absolute", left: "20px", top: "30px",paddingBottom:"3rem" }}>{translate(TranslationEnum.master_data_reports,"Master Data Reports")}</Typography>
      <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
  <Button 
    variant="contained" 
    color="primary" 
    onClick={handleBackClick} 
    style={{ color: "white", backgroundColor: "#24c6b1", fontWeight: "bold" }}
  >
    {translate(TranslationEnum.common_portal,"BACK")}
  </Button>
</div>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header} sx={{ color: '#8392AB', fontWeight: 'bold',paddingBottom: '0.5rem',fontSize:"0.65rem" }} align="center">
                 {translate(TranslationEnum.master_data_reports,header)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {masterDataReports.map((row, index) => (
            <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f5f5f5' }, height: '3rem'}}>
              <TableCell style={{ fontSize: '0.8rem', paddingRight: '0.75rem',color: '#67748e',fontWeight:580}} align="center">{row.fileName}</TableCell>
              <TableCell style={{ fontSize: '0.8rem', paddingRight: '0.75rem',color: '#67748e',fontWeight:580 }} align="center">{row.branch}</TableCell>
              <TableCell style={{ fontSize: '0.8rem', paddingRight: '0.75rem',color: '#67748e',fontWeight:580 }} align="center">{row.size}</TableCell>
              <TableCell style={{ fontSize: '0.8rem', paddingRight: '0.75rem',color: '#67748e',fontWeight:580 }} align="center">{formatDate(row.timestamp)}</TableCell>             
              <TableCell style={{ fontSize: '0.9rem', paddingRight: '0.75rem', color: '#67748e'}} align="center"><a className="hoverLink" href={`https://analytics.sellina.io/${row.fileName}`}> Download </a></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
}
